import React from "react";
import styled from 'styled-components';
// import nota from '../Global/nota.guidelines.json';

import NanoFlex from '../Global/NanoFlex.js';
import Checkbox from '../Nano/Checkbox.js';

import { getRandomArbitrary } from '../Global/tools.js';

const mock = new Array(4).fill(null).map( (v, i) => {
    const fakeId = getRandomArbitrary(1000, 9999);
    return {
      id: i,
      label: `Label ${fakeId}`
    };
});

const StyledRadioButtons = styled.div`
`;

const RadioLoop = (props) => !props.data ? null : props.data.map( (obj, i) =>
<Checkbox
    check
    radio
    key={i}
    id={obj.id}
    toggle={props.selectedId || props.selectedId === 0 ? props.selectedId === obj.id : false}
    label={obj.label}
    labelSize={'h4'}
    onChangeAction={() => props.onToggleAction(obj.id)}
/>);

class RadioButtons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedId: this.props.selectedId ? this.props.selectedId : null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedId !== this.state.selectedId) {
            this.props.onChangeSelection(this.state.selectedId);
        };

        if (prevProps.selectedId !== this.props.selectedId) {
            this.setState({ selectedId: this.props.selectedId });
        };
    }

    toggleSelectedId = (id) => {
        if (id === undefined) return;
        this.setState({ selectedId: this.state.selectedId === id ? null : id });
    }

    render() {
        return (
            <StyledRadioButtons>
                {this.props.data &&
                <NanoFlex flexDirection='column' width={'100%'}>
                    <RadioLoop
                        data={this.props.data}
                        selectedId={this.state.selectedId}
                        onToggleAction={(id) => this.toggleSelectedId(id)}
                    />
                </NanoFlex>}
            </StyledRadioButtons>
        );
    }
};

// Set default props
RadioButtons.defaultProps = {
    data: mock
};

export default RadioButtons;

// --- // Documentation // --- //
/*
import RadioButtons from './../Nano/RadioButtons.js';

<RadioButtons/>
*/
